<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="account">Bank Account</label>
            <Dropdown v-model="account" :options="bankList"
                      optionLabel="name"
                      :rowsPerPageOptions="[100,500,1000]"
                      :rows="100" :filters="filters"
                      :showClear="true" id="account"
                      placeholder="Select Bank">
            </Dropdown>

          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="fromDate">From Date</label>
            <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label for="toDate">To Date</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button @click.prevent="searchPartyStatement"
                    class="p-button-raised" label="Search" icon="pi pi-search"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button v-if="this.postDateChequeList.length > 0" @click.prevent="reset"
                    class="p-button-raised p-button-warning" label="Reset" icon="pi pi-refresh"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
          </div>
        </div>
      </form>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <a href="#" @click.prevent="exportCSV()" v-if="this.postDateChequeList.length > 0">
            <img src="../../../../static/img/excel.png" style="float: right;height: 3em;width: 3em;"/>
          </a>
          <DataTable :value="postDateChequeList"
                     :paginator="true"
                     edit-mode="cell"
                     :rows="10" :filters="filters" editMode="cell"
                     class="p-datatable-responsive-demo p-datatable-gridlines editable-cells-table"
                     data-key="id">
            <template #empty>No record found</template>
            <Column header="S.N">
              <template #body="sl">{{ sl.index + 1 }}</template>
            </Column>
            <Column :sortable="true" header="Miti" field="transactionDateNepali" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDateNepali']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Date" field="transactionDate" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDate']"/>
              </template>
            </Column>
            <Column :sortable="true" headerStyle="width:8em;" header="VouType" field="moduleType"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['moduleType']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Voucher" field="voucher" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['voucher']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Particulars" field="accountName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
              </template>
            </Column>

            <Column :sortable="true" headerStyle="width:10em;" header="Cheque Date" field="chequeDate"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['chequeDate']"/>
              </template>
            </Column>
            <Column :sortable="true" headerStyle="width:8em;" header="Cheque Number" field="chequeNumber"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['chequeNumber']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Deposited" bodyStyle="color:#00a65a;text-align: right" field="debitBalance"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['debitBalance']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Withdraw" bodyStyle="color:#dd4b39;text-align: right" field="creditBalance"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['creditBalance']"/>
              </template>
            </Column>
            <Column header="Clear Date" field="chequeClearingDateNepali">
              <template #body="slotProps">
                <Button style="float:right;" class="p-button-raised p-button-secondary"
                        @click="showChequeDate(slotProps.data.chequeClearingDateNepali, slotProps.index)"
                        label="Date" icon="pi pi-save"/>
              </template>
            </Column>
          </DataTable>
        </div>
        <div class="p-field p-col-12 p-md-1">
          <Button style="float:right;" class="p-button-raised p-button-success" @click="postDateCheque"
                  label="Post" icon="pi pi-save"/>
        </div>
      </div>
      <Dialog header="Cheques Clear date" :closable=false @show="setClearDate"
              :visible.sync="chequeDateDialog" :style="{width: '50vw'}" :modal="true"
              :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label>Cheque Date</label>
            <date-picker v-model="chequeClearingDate" v-if="!englishDateEnabled"
                         valueType="format" id="clearDate"/>
            <InputMask mask="9999-99-99" class="nepali-calendar" id="clearDate"
                       v-model="chequeClearingDate"/>
          </div>
        </div>
        <template #footer>
          <Button style="float:right;" class="p-button-raised " @click.prevent="saveChequeDate"
                  label="Save" icon="pi pi-save"/>
          <Button style="float:right;" class="p-button-raised p-button-danger " @click="cancel"
                  label="Cancel"/>
        </template>
      </Dialog>
    </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'

export default {
  data() {
    return {
      loading: false,
      fromDate: null,
      toDate: null,
      chequeClearingDate: null,
      postDateChequeList: [],
      bankList: [],
      account: '',
      accountMasterId: null,
      filters: {},
      ind: null,
      chequeDateDialog: false,
      englishDateEnabled: true
    }
  },
  mounted() {
    this.bank()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async bank() {
      let response = await this.$store.dispatch('loadBankList')
      this.bankList = response.data.data
    },
    showChequeDate(chequeClearingDateNepali, index) {
      this.chequeClearingDate = chequeClearingDateNepali
      this.ind = index
      this.chequeDateDialog = true
    },
    saveChequeDate() {
      this.postDateChequeList[this.ind].chequeClearingDateNepali = this.chequeClearingDate
      this.cancel()
    },
    cancel() {
      this.chequeDateDialog = false
    },
    async searchPartyStatement() {
      if (this.account === '' || this.account === null) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Please select at least one bank!', life: 3000})
        return
      }
      if (this.account === '') {
        this.accountMasterId = 0
      } else {
        this.accountMasterId = this.account.id
      }
      let bankStatementObject = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        bankId: this.accountMasterId
      }
      this.loading = true
      let response = await this.$store.dispatch('loadPostDateCheque', bankStatementObject)
      this.loading = false
      if (response.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 3000})
      } else if (response.data.data.length > 0) {
        this.loaded = true
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        this.postDateChequeList = response.data.data
      }
    },
    async postDateCheque() {
      console.log(this.postDateChequeList)
      // // debugger
      this.loading = true
      let response = this.$store.dispatch('addPostChequeDate', this.postDateChequeList)
      this.loading = false
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
        this.chequeClearingDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      this.account = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.startDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    },
    setClearDate() {
      $('#clearDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.chequeClearingDate = $('#clearDate').val()
        }
      })
    }
  },
  components: {
    Dropdown,
    DatePicker,
    DataTable,
    Column,
    InputText,
    InputMask,
    Button,
    Dialog
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// postDateChequeDetails.vue?e27d6562